import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { spacer8, spacer12 } from '@spotify-internal/encore-foundation';
import { typeStyleBody2, overlay } from "../../styles";
var TooltipWrapper = styled.div.withConfig({
  displayName: "Tooltip__TooltipWrapper",
  componentId: "ljwgeo-0"
})(["", ";", ";padding:", " ", ";text-transform:initial;"], function (props) {
  var _props$theme;

  return overlay({
    maxWidth: '240px',
    isDarkTheme: ((_props$theme = props.theme) == null ? void 0 : _props$theme.tooltip) === 'dark'
  });
}, typeStyleBody2(), spacer8, spacer12);

function TooltipComponent(_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? {} : _ref$theme,
      props = _objectWithoutProperties(_ref, ["theme"]);

  return React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(TooltipWrapper, Object.assign({
    role: "tooltip"
  }, props)));
}

var tooltipHelper = {
  darkTheme: {
    tooltip: 'dark'
  }
};
export var Tooltip = Object.assign(TooltipComponent, tooltipHelper);
export default Tooltip;